export default __webpack_public_path__ + "static/media/toolsLight.3c8673df.png";